import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';
import { FaPlus, FaTrashAlt, FaThumbtack, FaBullhorn, FaEdit, FaSave, FaTimes } from 'react-icons/fa';

const DashboardManager = ({ posts = [], loading, onRefresh }) => {
  const { profile } = useAuth();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [category, setCategory] = useState('info');
  const [isPinned, setIsPinned] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const [editContent, setEditContent] = useState('');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    if (!title.trim() || !content.trim()) return;

    const { error } = await supabase.from('dashboard_posts').insert({
      title: title.trim(),
      content: content.trim(),
      category,
      is_pinned: isPinned,
      author: profile?.name || 'Admin',
    });

    if (error) {
      setMsg("Erreur lors de la publication : " + error.message);
    } else {
      setMsg("Annonce publiée avec succès !");
      setTitle('');
      setContent('');
      setIsPinned(false);
      if (onRefresh) onRefresh(); // Rechargement immédiat
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Voulez-vous vraiment supprimer cette annonce ?")) {
      const { error } = await supabase.from('dashboard_posts').delete().eq('id', id);
      if (error) {
        setMsg("Erreur de suppression : " + error.message);
      } else {
        if (onRefresh) onRefresh(); // Rechargement immédiat
      }
    }
  };

  const handleStartEdit = (post) => {
    setEditingId(post.id);
    setEditTitle(post.title);
    setEditContent(post.content);
  };

  const handleSaveEdit = async (id) => {
    const { error } = await supabase
      .from('dashboard_posts')
      .update({ title: editTitle.trim(), content: editContent.trim() })
      .eq('id', id);

    if (error) {
      setMsg("Erreur lors de la modification : " + error.message);
    } else {
      setEditingId(null);
      if (onRefresh) onRefresh(); // Rechargement immédiat
    }
  };

  const togglePin = async (id, currentStatus) => {
    await supabase.from('dashboard_posts').update({ is_pinned: !currentStatus }).eq('id', id);
    if (onRefresh) onRefresh(); // Rechargement immédiat
  };

  return (
    <div className="membres-section" style={{ marginTop: '30px', borderTop: '2px solid rgba(255,255,255,0.1)', paddingTop: '20px' }}>
      <h3><FaBullhorn /> Espace Gestion du Tableau de Bord (Admin / Mise en Scène)</h3>

      <form onSubmit={handleSubmit} className="membres-form" style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Titre de l'annonce..."
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
          style={{ width: '100%', marginBottom: '10px', padding: '10px', borderRadius: '6px' }}
        />

        <textarea
          placeholder="Contenu de l'annonce..."
          value={content}
          onChange={(e) => setContent(e.target.value)}
          rows="4"
          required
          style={{ width: '100%', marginBottom: '10px', padding: '10px', borderRadius: '6px' }}
        />

        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '15px', flexWrap: 'wrap' }}>
          <label>
            Catégorie :{' '}
            <select value={category} onChange={(e) => setCategory(e.target.value)} style={{ padding: '6px', borderRadius: '4px' }}>
              <option value="info">ℹ️ Information générale</option>
              <option value="urgent">🚨 Important / Urgent</option>
              <option value="repetition">🎭 Répétition / Spectacle</option>
            </select>
          </label>

          <label style={{ cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={isPinned}
              onChange={(e) => setIsPinned(e.target.checked)}
              style={{ marginRight: '6px' }}
            />
            Épingler en haut
          </label>
        </div>

        {msg && <p style={{ color: '#007bff', marginBottom: '10px' }}>{msg}</p>}

        <button type="submit" className="membres-btn">
          <FaPlus /> Publier l'annonce
        </button>
      </form>

      <h4>Gérer les annonces existantes</h4>
      {loading ? (
        <p>Chargement...</p>
      ) : (
        <ul className="membres-feed" style={{ listStyle: 'none', paddingLeft: 0 }}>
          {posts.map((p) => (
            <li key={p.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px', padding: '12px', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
              {editingId === p.id ? (
                <div style={{ flex: 1 }}>
                  <input
                    type="text"
                    value={editTitle}
                    onChange={(e) => setEditTitle(e.target.value)}
                    style={{ width: '100%', marginBottom: '8px', padding: '6px' }}
                  />
                  <textarea
                    value={editContent}
                    onChange={(e) => setEditContent(e.target.value)}
                    rows="3"
                    style={{ width: '100%', padding: '6px' }}
                  />
                  <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                    <button type="button" className="membres-btn" onClick={() => handleSaveEdit(p.id)}><FaSave /> Enregistrer</button>
                    <button type="button" className="membres-btn" style={{ backgroundColor: '#6c757d' }} onClick={() => setEditingId(null)}><FaTimes /> Annuler</button>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ flex: 1 }}>
                    <strong>{p.is_pinned && '📌 '}{p.title}</strong>{' '}
                    <small>({p.category}) — par {p.author}</small>
                    <p style={{ marginTop: '5px', whiteSpace: 'pre-wrap' }}>{p.content}</p>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      type="button"
                      onClick={() => handleStartEdit(p)}
                      style={{ background: 'none', border: 'none', color: '#17a2b8', cursor: 'pointer' }}
                      title="Modifier"
                    >
                      <FaEdit />
                    </button>
                    <button
                      type="button"
                      onClick={() => togglePin(p.id, p.is_pinned)}
                      style={{ background: 'none', border: 'none', color: p.is_pinned ? '#f1c40f' : '#666', cursor: 'pointer' }}
                      title={p.is_pinned ? 'Désépingler' : 'Épingler'}
                    >
                      <FaThumbtack />
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDelete(p.id)}
                      style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}
                      title="Supprimer"
                    >
                      <FaTrashAlt />
                    </button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DashboardManager;